import React from 'react';
import UpSortIcon from '../icons/UpSortIcon';
import DownSortIcon from '../icons/DownSortIcon';
import UnsortIcon from '../icons/UnsortIcon';

const TableHeaderCell = ({ header, onSort, currentSortKey, currentSortDirection }) => {
  const isCurrentSortKey = currentSortKey === header.key;

  const SortIcon = () => {
    if (!header.sortable) {
      return null;
    }

    if (isCurrentSortKey) {
      if (currentSortDirection === 'asc') {
        return <UpSortIcon />;
      }
      if (currentSortDirection === 'desc') {
        return <DownSortIcon />;
      }
    }
    return <UnsortIcon />;
  };

  const handleSort = () => {
    if (header.sortable) {
      onSort(header.key);
    }
  };

  return (
    <th
      onClick={handleSort}
      style={{
        cursor: header.sortable ? 'pointer' : 'default',
        color: "#71717a",
        padding: "16px 12px",
        fontWeight: 500,
        fontSize: 16,
        fontFamily: "inherit",
        verticalAlign: "middle",
        borderBottom: "2px solid #e5e7eb",
        textAlign: "left"
      }}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        {header.value}
        <SortIcon />
      </span>
    </th>
  );
};

export default TableHeaderCell;
